'use client';

import { useEffect } from 'react';
import { initWebVitals } from '@/lib/webVitals';
import { markPerformance, measurePerformance } from '@/lib/performance/monitoring';
import { HeaderVisibilityProvider } from '@/contexts/HeaderVisibilityContext';

export function ClientProviders({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    // Mark hydration start
    markPerformance('react-hydration-start');
    
    // Initialize Web Vitals monitoring
    if (typeof window !== 'undefined') {
      initWebVitals();
      
      // Mark app as interactive
      document.documentElement.classList.add('js-loaded');
      
      // Remove no-js fallbacks
      document.documentElement.classList.remove('no-js');
    }

    // Register Service Worker
    if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
      window.addEventListener('load', () => {
        navigator.serviceWorker
          .register('/sw.js')
          .then((registration) => {
            // Service Worker registered successfully
            
            // Check for updates periodically
            setInterval(() => {
              registration.update();
            }, 60000); // Check every minute
          })
          .catch(() => {
            // Service Worker registration failed
          });
      });
    }
    
    // Preload non-critical CSS after hydration
    // Note: Removed preloading of non-existent CSS files to fix 404 errors
    
    // Measure hydration complete
    measurePerformance('react-hydration', 'react-hydration-start');
  }, []);

  return (
    <HeaderVisibilityProvider>
      {children}
    </HeaderVisibilityProvider>
  );
}